import timeZoneMapping from './timezone-mappings'

const lang = navigator.language

function formatStartAtForOverviewList (startAt: number): string {
  const options = { weekday: 'short', month: 'short', day: 'numeric', hour12: true, hour: 'numeric', minute: '2-digit' }
  let eventStartsAt = new Date(startAt * 1000)

  return eventStartsAt.toLocaleDateString(lang, options)
}

function isPastEvent (eventEndDate: number): boolean {
  const currentDate = new Date()
  const endDate = new Date(eventEndDate * 1000)

  return currentDate > endDate
}

function formatDateForEventView (eventStartDate: number, eventEndDate: number, showTimeZone: boolean): string {
  const startDate = new Date(eventStartDate * 1000)
  const endDate = new Date(eventEndDate * 1000)

  const dateOptions = {
    weekday: 'short',
    month: 'short',
    day: 'numeric'
  }
  const timeOptions = {
    hour12: true,
    hour: 'numeric',
    minute: '2-digit'
  }
  const dateTimeOptions = { ...dateOptions, ...timeOptions }
  const formattedStartDate = startDate.toLocaleDateString(lang, dateTimeOptions)

  if (isSameDate(startDate, endDate)) {
    const formattedEndTime = endDate.toLocaleTimeString(lang, timeOptions)

    if (showTimeZone) {
      let formattedTimeZone = timeZone(startDate)
      return `${formattedStartDate} - ${formattedEndTime} (${formattedTimeZone})`
    }
    return `${formattedStartDate} - ${formattedEndTime}`
  }

  const formattedEndDate = endDate.toLocaleDateString(lang, dateTimeOptions)
  if (showTimeZone) {
    let formattedTimeZone = timeZone(startDate)
    return `${formattedStartDate} - ${formattedEndDate} (${formattedTimeZone})`
  }
  return `${formattedStartDate} - ${formattedEndDate}`
}

function isSameDate (d1: Date, d2: Date) {
  return d1.getFullYear() === d2.getFullYear() && d1.getMonth() === d2.getMonth() && d1.getDate() === d2.getDate()
}

function timeZone (startDate: Date) {
  let timeZoneFull = startDate.toTimeString().split('(')[1].slice(0, -1)
  return timeZoneMapping[timeZoneFull] ?? timeZoneFull
}

function formatDateForGoogleCalenderLink (date: number): string {
  return new Date(date * 1000).toISOString().replace(/-|:|\.\d\d\d/g, '')
}

export default { formatStartAtForOverviewList, formatDateForEventView, isPastEvent, formatDateForGoogleCalenderLink }
